// Kurstexte, mit denselben Slugs wie in app/data/courses.ts.
const de = {
  badgeNew: "Neu",

  ai: {
    title: "KI und maschinelles Lernen",
    short:
      "Entwickeln Sie intelligente Anwendungen, von den Grundlagen des maschinellen Lernens bis zu LLMs und AI agents.",
    long: "Beginnen Sie mit Python und der Datenverarbeitung, auf denen das Fachgebiet aufbaut, und arbeiten Sie sich dann durch die Grundlagen des maschinellen Lernens: wie ein Modell aus Daten lernt, warum es überanpasst und wie Sie ein gutes Ergebnis von einem glücklichen Zufall unterscheiden. Von dort geht es weiter zu neuronalen Netzen und Deep Learning und anschließend zu den Werkzeugen, die die Branche gerade jetzt umbauen: große Sprachmodelle, Prompt Engineering, Retrieval und AI agents, die echte Werkzeuge aufrufen. Zum Abschluss entwickeln und deployen Sie eine eigene Anwendung. Mathematik über das Schulniveau hinaus wird nicht vorausgesetzt, und jede Sitzung ist praxisnah, mit einem Dozenten an Ihrer Seite.",
    level: "Anfänger bis Fortgeschrittene",
    duration: "10-14 Wochen",
    topics: [
      "Python für KI und Daten",
      "Grundlagen des maschinellen Lernens",
      "Neuronale Netze und Deep Learning",
      "Große Sprachmodelle (LLMs)",
      "Prompt Engineering",
      "AI agents und Anwendungen entwickeln",
    ],
  },

  algorithms: {
    title: "Algorithmen",
    short:
      "Entwerfen und implementieren Sie Algorithmen, um komplexe Probleme effizient zu lösen.",
    long: "Lernen Sie, abzuschätzen, was ein Programm kostet, bevor Sie es ausführen. Der Kurs beginnt mit Sortieren, Suchen und der Big-O-Notation und arbeitet sich dann über Rekursion, Backtracking, dynamische Programmierung, Greedy-Verfahren und Graphentheorie vor. Jedes Thema lernen Sie, indem Sie den Algorithmus selbst schreiben und ihn anschließend gezielt zum Scheitern bringen, damit Sie verstehen, wo er versagt und warum die Implementierung in der Standardbibliothek so aussieht, wie sie aussieht. Das ist der Kurs, der technische Bewerbungsgespräche beherrschbar macht, und der jene, die Code schreiben können, von jenen unterscheidet, die beurteilen können, ob dieser Code unter Last standhält.",
    level: "Anfänger bis Fortgeschrittene",
    duration: "8-12 Wochen",
    topics: [
      "Sortieren und Suchen",
      "Komplexität und Big-O",
      "Rekursion und Backtracking",
      "Dynamische Programmierung",
      "Graphentheorie",
      "Greedy-Algorithmen",
    ],
  },

  programming: {
    title: "Grundlagen der Programmierung",
    short:
      "Bauen Sie ein solides Fundament in Programmierung, Problemlösung und sauberem Code auf.",
    long: "Der Ausgangspunkt, wenn Sie noch nie eine Zeile Code geschrieben haben. Sie beginnen mit Variablen, Typen, Kontrollfluss und Schleifen und gehen dann zu Funktionen, Gültigkeitsbereich und dem Aufbau eines Programms über, das lesbar bleibt, während es wächst. Unterwegs begegnen Ihnen objektorientierte Programmierung, Fehlerbehandlung und die Gewohnheiten, die Code, der bloß läuft, von Code unterscheiden, den jemand anderes pflegen kann. Der Schwerpunkt liegt durchgehend auf dem Lösen von Problemen statt auf dem Auswendiglernen von Syntax: Am Ende können Sie ein in normaler Sprache formuliertes Problem nehmen und es selbst in ein funktionierendes Programm verwandeln.",
    level: "Anfänger",
    duration: "6-10 Wochen",
    topics: [
      "Variablen und Datentypen",
      "Kontrollfluss und Schleifen",
      "Funktionen und Gültigkeitsbereich",
      "Objektorientierte Programmierung",
      "Fehlerbehandlung",
      "Grundlagen sauberen Codes",
    ],
  },

  architecture: {
    title: "Softwaredesign und Architektur",
    short: "Prinzipien für skalierbare, wartbare Softwaresysteme.",
    long: "Für Entwickler, die bereits Funktionen bauen können und nun Systeme entwerfen wollen. Der Kurs behandelt die SOLID-Prinzipien und die Design Patterns, die man kennen sollte, und geht dann zum eigentlichen Systementwurf über: wie man eine Domäne zerlegt, wo man Servicegrenzen zieht, wann Microservices helfen und wann sie ein teurer Fehler sind. Sie arbeiten Skalierbarkeit, Caching, Performance und Fehlerfälle an echten Architekturen durch und üben, die technischen Dokumente zu schreiben, die einen Entwurf durch die Freigabe bringen. Rechnen Sie damit, ebenso viel Zeit mit dem Verteidigen Ihrer Entscheidungen zu verbringen wie mit dem Treffen dieser Entscheidungen.",
    level: "Fortgeschrittene bis Experten",
    duration: "8-12 Wochen",
    topics: [
      "SOLID-Prinzipien",
      "Design Patterns",
      "Systementwurf",
      "Skalierbarkeit und Performance",
      "Microservices",
      "Technische Dokumentation",
    ],
  },

  web: {
    title: "Webentwicklung",
    short: "Entwickeln Sie moderne Web-Apps, vom Frontend bis zum Backend.",
    long: "Entwickeln Sie Webanwendungen vom Browser bis zur Datenbank. Sie beginnen mit semantischem HTML und modernem CSS-Layout, dann JavaScript richtig statt als Sammlung von Codeschnipseln, dann React und wie ein Komponentenbaum tatsächlich rendert. Die zweite Hälfte behandelt Node.js, den Entwurf einer API, die Kommunikation mit einer Datenbank, Authentifizierung und das Deployen des Ergebnisses, damit andere es nutzen können. Sie gehen mit einer Full-Stack-Anwendung, die Sie selbst gebaut haben, und mit einem Verständnis dafür, was zwischen dem Eintippen einer URL und dem Erscheinen einer Seite geschieht.",
    level: "Anfänger bis Fortgeschrittene",
    duration: "10-14 Wochen",
    topics: [
      "HTML und CSS",
      "JavaScript",
      "React",
      "Node.js und APIs",
      "Datenbanken",
      "Deployment",
    ],
  },

  mobile: {
    title: "Mobile Entwicklung",
    short:
      "Veröffentlichen Sie Apps für iOS und Android, nativ und plattformübergreifend.",
    long: "Veröffentlichen Sie Anwendungen für beide großen Mobilplattformen. Sie arbeiten zunächst nativ, mit Swift unter iOS und Kotlin unter Android, damit Sie die Konventionen jeder Plattform verstehen, statt sie durch eine Abstraktion zu bekämpfen. Danach bauen Sie dieselbe Anwendung plattformübergreifend in Flutter und React Native und sehen genau, was Sie jeder Ansatz kostet. Der Kurs behandelt State Management, lokale Speicherung, den Umgang mit Geräte-APIs und die Teile, die niemand unterrichtet: die Prüfung im App Store, Versionierung und das Ausliefern eines Updates, ohne denjenigen etwas kaputtzumachen, die die App bereits nutzen.",
    level: "Fortgeschrittene",
    duration: "10-14 Wochen",
    topics: [
      "Swift (iOS)",
      "Kotlin (Android)",
      "Flutter",
      "React Native",
      "State und Speicherung",
      "Veröffentlichung in den Stores",
    ],
  },

  server: {
    title: "Datenbank- und Serverentwicklung",
    short: "Entwerfen und betreiben Sie Datenbanken, APIs und Deployments.",
    long: "Alles, was passiert, nachdem die Anfrage den Browser verlassen hat. Sie lernen, Daten in SQL sauber zu modellieren, wann ein Dokument- oder Key-Value-Store die bessere Antwort ist und wie Sie einen Query-Plan lesen, wenn etwas langsam ist. Von dort behandelt der Kurs serverseitige Programmierung, den Entwurf von REST- und GraphQL-APIs, Authentifizierung und die Sicherheitsfehler, die es in die Schlagzeilen schaffen, dann Caching und Hintergrund-Queues für den Fall, dass eine einzelne Anfrage zu viel tut. Er endet mit Deployment, Monitoring und der betrieblichen Seite, einen Dienst am Laufen zu halten, sobald echte Nutzer von ihm abhängen.",
    level: "Fortgeschrittene",
    duration: "8-12 Wochen",
    topics: [
      "SQL und NoSQL",
      "Serverseitige Programmierung",
      "REST- und GraphQL-APIs",
      "Authentifizierung und Sicherheit",
      "Caching und Queues",
      "Deployment und DevOps",
    ],
  },

  career: {
    title: "Lebenslauf & Jobsuche",
    short:
      "Schreiben Sie einen Lebenslauf, der zu Gesprächen führt, und suchen Sie so, dass am Ende ein Angebot steht.",
    long: "Eingestellt zu werden ist eine eigene Fähigkeit, getrennt davon, die Arbeit zu beherrschen. Der Kurs beginnt damit, wie Recruiting wirklich abläuft: Wer liest Ihren Lebenslauf, wie lange, und was die Vorauswahl-Software aussortiert, bevor ein Mensch etwas sieht. Sie überarbeiten Ihren Lebenslauf sowie Ihre LinkedIn- und GitHub-Profile anhand dieser Realität, bauen ein Portfolio auf, das Ihre Angaben belegt, und lernen, Stellen jenseits der Jobbörsen zu finden, die alle anderen ständig aktualisieren. Danach üben Sie den Rest des Wegs: Bewerbungen, Vorstellungsgespräche mit Simulationen und ehrlichem Feedback, und das Verhandeln eines Angebots, ohne sich unter Wert zu verkaufen. Die Materialien decken den deutschen und europäischen Markt sowie internationale Bewerbungen ab.",
    level: "Alle Erfahrungsstufen",
    duration: "4-6 Wochen",
    topics: [
      "Aufbau und Struktur des Lebenslaufs",
      "LinkedIn- und GitHub-Profile",
      "Ein Portfolio aufbauen",
      "Stellen finden und sich bewerben",
      "Training für Vorstellungsgespräche",
      "Gehaltsverhandlung",
    ],
  },
};

export default de;
